var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useMemo } from 'react';
import { PhoneIcon, MailIcon, MessageIcon, UserIcon } from 'src/assets/Images';
import { TableContainer } from './styles';
import { StyledPaper } from '../Common/Table/styles';
import { getAssigneeName, getClientType } from './utils';
import { TicketRow, TableHeader, TablePagination, LoadingState, EmptyState, } from './components';
import dayjs from 'dayjs';
var ROWS_PER_PAGE = 10;
var TicketsTable = function (_a) {
    var className = _a.className, _b = _a.tickets, tickets = _b === void 0 ? [] : _b, _c = _a.loading, loading = _c === void 0 ? false : _c, _d = _a.error, error = _d === void 0 ? null : _d, _e = _a.totalPages, totalPages = _e === void 0 ? 0 : _e, _f = _a.currentPage, currentPage = _f === void 0 ? 0 : _f, onPageChange = _a.onPageChange, _g = _a.isClientView, isClientView = _g === void 0 ? false : _g;
    var getCommunicationIcon = useCallback(function (channel) {
        switch (channel) {
            case 'email':
                return React.createElement("img", { src: MailIcon, alt: "Mail" });
            case 'phone':
                return React.createElement("img", { src: PhoneIcon, alt: "Phone" });
            case 'whatsapp':
                return React.createElement("img", { src: MessageIcon, alt: "Message" });
            default:
                return React.createElement("img", { src: UserIcon, alt: "User" });
        }
    }, []);
    var processedTickets = useMemo(function () {
        return tickets.map(function (ticket, index) { return (__assign(__assign({}, ticket), { assigneeName: getAssigneeName(ticket), clientType: getClientType(ticket), duration: dayjs(ticket.created_at).fromNow(), communicationIcon: getCommunicationIcon(ticket.communication_channel), isHighlighted: index % 2 === 1 })); });
    }, [tickets, getCommunicationIcon]);
    var handleChangePage = function (event, newPage) {
        onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(newPage);
    };
    if (loading) {
        return React.createElement(LoadingState, null);
    }
    if (error) {
        var entityLabel = isClientView ? 'reclamos' : 'tickets';
        return (React.createElement(EmptyState, { message: "Error al cargar los " + entityLabel + ": " + error }));
    }
    if (tickets.length === 0) {
        return (React.createElement(EmptyState, { message: isClientView ? 'No hay reclamos disponibles' : 'No hay tickets disponibles' }));
    }
    return (React.createElement(StyledPaper, null,
        React.createElement(TableContainer, { className: className },
            React.createElement(TableHeader, { hideReminders: isClientView, isClientView: isClientView }),
            processedTickets.map(function (ticket) { return (React.createElement(TicketRow, { key: ticket.id, ticket: ticket, isClientView: isClientView })); })),
        React.createElement(TablePagination, { count: totalPages * ROWS_PER_PAGE, page: currentPage, rowsPerPage: ROWS_PER_PAGE, onPageChange: handleChangePage })));
};
export default TicketsTable;
